const sortCompanies = (order, items) => {
  const callBack = getSortCallback(order)
  return items.sort(callBack)
}

function getSortCallback(sort) {
  return (catalogA, catalogB) => {
    const result = sortDescending(catalogA, catalogB, sort.sortBy)
    return sort.sortDir === "desc" ? result : result * -1
  }
}

function sortDescending(catalogA, catalogB, key) {
  if (typeof key !== "string") return 0
  return String(catalogA[key]).localeCompare(String(catalogB[key]), undefined, {
    sensitivity: "base"
  })
}

export default sortCompanies
